export { default } from './IconPDF';